import { render, staticRenderFns } from "./Thankyou.vue?vue&type=template&id=3d33dd8a&scoped=true&"
import script from "./Thankyou.vue?vue&type=script&lang=ts&"
export * from "./Thankyou.vue?vue&type=script&lang=ts&"
import style0 from "./Thankyou.vue?vue&type=style&index=0&id=3d33dd8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d33dd8a",
  null
  
)

export default component.exports